import { render } from "./bio.vue?vue&type=template&id=703e773d"
import script from "./bio.vue?vue&type=script&lang=js"
export * from "./bio.vue?vue&type=script&lang=js"

import "./bio.vue?vue&type=style&index=0&id=703e773d&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__